import loadContextData from "../../utils/loadContextData";
import createTemplate from "../../utils/createTemplate";
import getDevice from "../../utils/getDevice";

let particlesCounter = 0;
let adCodeCounter = 0;

function createAdNode(adBlock) {
    const device = getDevice();
    let adCodeHtml;
    if (adBlock && device in adBlock) {
        adCodeHtml = adBlock[device];
    }
    if (adCodeHtml) {
        return createTemplate(adCodeHtml).getElement();
    } else {
        return null;
    }
}

export default function injectAssemblerAds(postId) {
    const adsContext = loadContextData(`#assembler-ad-config-${postId}`);
    if (!Object.keys(adsContext).length) {
        return null;
    }

    const { adsOrder, adCodes } = adsContext;
    const [adEveryNth] = adsOrder;

    if (particlesCounter++ % adEveryNth === 0) {
        return createAdNode(adCodes[adCodeCounter++] || adCodes[(adCodeCounter = 0)]);
    } else {
        return null;
    }
}
